import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _size from "lodash/size";
import _isError from "lodash/isError";
import _map from "lodash/map";
import _mapValues from "lodash/mapValues";
import _groupBy from "lodash/groupBy";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/* eslint-disable no-nested-ternary */
import './index.css';
import { ErrorBoundary } from '@datacamp/le-shared-components';
import * as React from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import orderGroupedItems from '../../lib/orderGroupedItems';
import { sentry } from '../../lib/sentry';
import ActionBar from './ActionBar';
import ClassifyList from './layout/ClassifyList';
import OrderList from './layout/OrderList';
import TwoList from './layout/TwoList';
import { jsx as ___EmotionJSX } from "@emotion/react";
const InteractiveDnd = _ref => {
  let {
    checkExercise,
    disableActionButtons,
    groupedItems,
    initialGroupedItems,
    itemsSolution,
    orderGroupedItems: orderGroupedItemsProp,
    scts,
    setItemOffset,
    solutionShown,
    targets
  } = _ref;
  const [error, setError] = React.useState(null);

  // Store initial grouped items
  React.useEffect(() => {
    orderGroupedItemsProp(groupedItems);
  }, [groupedItems, orderGroupedItemsProp]);
  const onDragEnd = React.useCallback(result => orderGroupedItemsProp(orderGroupedItems(groupedItems, targets, result)), [groupedItems, orderGroupedItemsProp, targets]);
  React.useEffect(() => {
    if (solutionShown > 0) {
      orderGroupedItemsProp(_groupBy(itemsSolution, 'target'));
    }
  }, [itemsSolution, orderGroupedItemsProp, solutionShown]);
  const onDragStart = React.useCallback(() => {
    const newGroupedItems = _mapValues(groupedItems, items => _map(items, item => _objectSpread(_objectSpread({}, item), {}, {
      highlight: false,
      status: undefined
    })));
    orderGroupedItemsProp(newGroupedItems);
  }, [groupedItems, orderGroupedItemsProp]);
  if (_isError(error) || _size(targets) === 0) {
    return ___EmotionJSX(ErrorBoundary, {
      forceToShow: true,
      onErrorReported: sentry.captureError
    });
  }
  return ___EmotionJSX("div", {
    className: "dc-u-fx dc-u-fx-fdc dc-u-h-100pc interactive-dnd"
  }, ___EmotionJSX(DragDropContext, {
    onDragEnd: onDragEnd,
    onDragStart: onDragStart
  }, targets.length > 2 ? ___EmotionJSX(ClassifyList, {
    groupedItems: groupedItems,
    orderGroupedItems: orderGroupedItemsProp,
    setItemOffset: setItemOffset,
    targets: targets
  }) : targets.length === 2 ? ___EmotionJSX(TwoList, {
    groupedItems: groupedItems,
    setItemOffset: setItemOffset,
    targets: targets
  }) : ___EmotionJSX(OrderList, {
    groupedItems: groupedItems,
    setItemOffset: setItemOffset,
    target: targets[0]
  })), ___EmotionJSX(ActionBar, {
    checkExercise: checkExercise,
    disabled: disableActionButtons,
    groupedItems: groupedItems,
    initialGroupedItems: initialGroupedItems,
    itemsSolution: itemsSolution,
    scts: scts,
    setError: setError,
    setGroupedItems: orderGroupedItemsProp
  }));
};
export default InteractiveDnd;